import cx from 'classnames';
import {
  Nav as BootstrapNav,
  NavLinkProps as BootstrapNavLinkProps,
  NavProps as BootstrapNavProps,
  Tab as BootstrapTab,
} from 'react-bootstrap';
import css from './Tab.module.scss';

const TabNav = ({ children, className = '', ...rest }: BootstrapNavProps) => (
  <BootstrapNav className={cx(css.tabNav, className)} {...rest}>
    {children}
  </BootstrapNav>
);

interface TabItemsProps extends BootstrapNavLinkProps {
  dividerRight?: boolean;
}

const TabItem = ({
  children,
  className,
  eventKey,
  dividerRight = false,
  ...rest
}: TabItemsProps) => (
  <BootstrapNav.Item
    className={cx(css.tabLinkContainer, { [css.dividerRight]: dividerRight })}
  >
    <BootstrapNav.Link
      className={cx(css.tabLink, className)}
      eventKey={eventKey}
      {...rest}
    >
      {children}
    </BootstrapNav.Link>
  </BootstrapNav.Item>
);

export const Tab = {
  Container: BootstrapTab.Container,
  Content: BootstrapTab.Content,
  Nav: TabNav,
  Pane: BootstrapTab.Pane,
  Item: TabItem,
};
